export const parseComponentName = (ComponentOrName = {}) =>
  ComponentOrName?.WrappedComponent?.name ?? ComponentOrName.name
